import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  selectIsWalletConnected,
  selectWalletConnectionMode,
  disconnectWallet,
  refreshWalletSnapshot,
} from '../store/slices/walletSlice';
import { getWalletConnectSession } from '../utils/activeEip1193Provider';

/**
 * 라우트·레이아웃과 무관하게 지갑 세션 이벤트를 Redux 와 맞춘다.
 * `App` 최상단에서 한 번만 마운트한다.
 */
export default function WalletSyncEffects() {
  const dispatch = useDispatch();
  const isWalletConnected = useSelector(selectIsWalletConnected);
  const walletConnectionMode = useSelector(selectWalletConnectionMode);

  useEffect(() => {
    if (!isWalletConnected) return undefined;

    if (walletConnectionMode === 'walletconnect') {
      const wc = getWalletConnectSession();
      if (!wc || typeof wc.on !== 'function') return undefined;

      const onDisconnect = () => {
        dispatch(disconnectWallet({ silent: true }));
      };
      const onAccounts = () => {
        dispatch(refreshWalletSnapshot());
      };
      const onChain = () => {
        dispatch(refreshWalletSnapshot());
      };

      wc.on('disconnect', onDisconnect);
      wc.on('accountsChanged', onAccounts);
      wc.on('chainChanged', onChain);

      return () => {
        if (typeof wc.removeListener === 'function') {
          wc.removeListener('disconnect', onDisconnect);
          wc.removeListener('accountsChanged', onAccounts);
          wc.removeListener('chainChanged', onChain);
        } else if (typeof wc.off === 'function') {
          wc.off('disconnect', onDisconnect);
          wc.off('accountsChanged', onAccounts);
          wc.off('chainChanged', onChain);
        }
      };
    }

    if (walletConnectionMode === 'injected' && typeof window !== 'undefined' && window.ethereum?.on) {
      const eth = window.ethereum;
      const onChain = () => dispatch(refreshWalletSnapshot());
      const onAccounts = (accounts) => {
        if (!accounts || accounts.length === 0) {
          dispatch(disconnectWallet({ silent: true }));
          return;
        }
        dispatch(refreshWalletSnapshot());
      };
      eth.on('chainChanged', onChain);
      eth.on('accountsChanged', onAccounts);
      return () => {
        eth.removeListener('chainChanged', onChain);
        eth.removeListener('accountsChanged', onAccounts);
      };
    }

    return undefined;
  }, [isWalletConnected, walletConnectionMode, dispatch]);

  return null;
}
